
export default {
  name: "MessageMore",

  data: function () {
    return {
      isMoreMessage: false,
      isShowButton: false
    }
  },

  props: {
    message: {
      type: String,
      default: ""
    },

    maxHeight: {
      type: Number,
      default: 76,
    }
  },

  mounted: function () {
    this.initDescription();
  },

  methods: {
    initDescription: function () {
      if (!this.message) {
        return
      }

      const messageHeight = this.$refs.refMessage.getBoundingClientRect().height;
      if (messageHeight <= this.maxHeight) {
        return;
      }

      this.isShowButton = true;
    },

    openCloseDescription: function () {
      this.isMoreMessage = !this.isMoreMessage;
    }
  }
}
